import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {BaseService} from './BaseService';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner'
import 'rxjs/add/operator/map';
import {of} from 'rxjs/observable/of';
import {tap} from 'rxjs/operators';
import {SealService} from './SealService';
import {CodeMasterVO} from '../model/CodeMasterVO';
import {MasterVO} from '../model/MasterVO';

@Injectable()
export class MasterHelper {



constructor(private http: HttpClient, private baseurl: BaseService, private spinnerService: Ng4LoadingSpinnerService,private masterVO: MasterVO) {}

filter(mastervalues) {
let PICKUP_MODE = "PICKUP_MODE";
let PICKUP_MODE1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == PICKUP_MODE);
this.masterVO.PICKUP_MODE =PICKUP_MODE1;
        
let COURIER = "COURIER";
let COURIER1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == COURIER);
this.masterVO.COURIER =COURIER1;
        
let PAYMENT_MODE = "PAYMENT_MODE";
let PAYMENT_MODE1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == PAYMENT_MODE);
this.masterVO.PAYMENT_MODE =PAYMENT_MODE1;
        
let MANUFACTURER = "MANUFACTURER";
let MANUFACTURER1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == MANUFACTURER);
this.masterVO.MANUFACTURER =MANUFACTURER1;
        
let ENCODING = "ENCODING";
let ENCODING1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == ENCODING);
this.masterVO.ENCODING =ENCODING1;
        
let SEAL_CONDITION = "SEAL_CONDITION";
let SEAL_CONDITION1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == SEAL_CONDITION);
this.masterVO.SEAL_CONDITION =SEAL_CONDITION1;
        
let MOVEMENT_TYPE = "MOVEMENT_TYPE";
let MOVEMENT_TYPE1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == MOVEMENT_TYPE);
this.masterVO.MOVEMENT_TYPE =MOVEMENT_TYPE1;
        
let STUFFING_TYPE = "STUFFING_TYPE";
let STUFFING_TYPE1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == STUFFING_TYPE);
this.masterVO.STUFFING_TYPE =STUFFING_TYPE1;
        
let ATTACHMENT_TYPE = "ATTACHMENT_TYPE";
let ATTACHMENT_TYPE1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == ATTACHMENT_TYPE);
this.masterVO.ATTACHMENT_TYPE =ATTACHMENT_TYPE1;
        
let INVOICE_CURRENCY = "INVOICE_CURRENCY";
let INVOICE_CURRENCY1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == INVOICE_CURRENCY);
this.masterVO.INVOICE_CURRENCY =INVOICE_CURRENCY1;
        
let FREIGHT_CURRENCY = "FREIGHT_CURRENCY";
let FREIGHT_CURRENCY1= mastervalues.filter((mas: CodeMasterVO) => mas.codetype == FREIGHT_CURRENCY);
this.masterVO.FREIGHT_CURRENCY =FREIGHT_CURRENCY1;
        
let SHIPMENT_MODE = "SHIPMENT_MODE";
let SHIPMENT_MODE1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == SHIPMENT_MODE);
this.masterVO.SHIPMENT_MODE =SHIPMENT_MODE1;
        
let IMPORT_PURCHASE_STATUS = "IMPORT_PURCHASE_STATUS";
let IMPORT_PURCHASE_STATUS1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == IMPORT_PURCHASE_STATUS);
this.masterVO.IMPORT_PURCHASE_STATUS =IMPORT_PURCHASE_STATUS1;
        
let PURPOSE = "PURPOSE";
let PURPOSE1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == PURPOSE);
this.masterVO.PURPOSE =PURPOSE1;
        
let PURCHASE_PAYMENT_MODE = "PURCHASE_PAYMENT_MODE";
let PURCHASE_PAYMENT_MODE1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == PURCHASE_PAYMENT_MODE);
this.masterVO.PURCHASE_PAYMENT_MODE =PURCHASE_PAYMENT_MODE1;
        
let BILL_TYPE = "BILL_TYPE";
let BILL_TYPE1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == BILL_TYPE);
this.masterVO.BILL_TYPE =BILL_TYPE1;
        
let PO_STATUS = "PO_STATUS";
let PO_STATUS1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == PO_STATUS);
this.masterVO.PO_STATUS =PO_STATUS1;
        
let FINANCIAL_YEAR = "FINANCIAL_YEAR";
let FINANCIAL_YEAR1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == FINANCIAL_YEAR);
this.masterVO.FINANCIAL_YEAR =FINANCIAL_YEAR1;
        
let CUSTOMS_CANCEL_REASON_FOR_REJECT = "CUSTOMS_CANCEL_REASON_FOR_REJECT";
let CUSTOMS_CANCEL_REASON_FOR_REJECT1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == CUSTOMS_CANCEL_REASON_FOR_REJECT);
this.masterVO.CUSTOMS_CANCEL_REASON_FOR_REJECT =CUSTOMS_CANCEL_REASON_FOR_REJECT1;
        
let CUSTOMS_CANCEL_REASON_FOR_TAMPER = "CUSTOMS_CANCEL_REASON_FOR_TAMPER";
let CUSTOMS_CANCEL_REASON_FOR_TAMPER1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == CUSTOMS_CANCEL_REASON_FOR_TAMPER);
this.masterVO.CUSTOMS_CANCEL_REASON_FOR_TAMPER =CUSTOMS_CANCEL_REASON_FOR_TAMPER1;
        
let USER_CANCEL_REASON = "USER_CANCEL_REASON";
let USER_CANCEL_REASON1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == USER_CANCEL_REASON);
this.masterVO.USER_CANCEL_REASON =USER_CANCEL_REASON1;
        
let IMPORT_FROM = "IMPORT_FROM";
let IMPORT_FROM1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == IMPORT_FROM);
this.masterVO.IMPORT_FROM = IMPORT_FROM1;

let READER_TYPE = "READER_TYPE";
let READER_TYPE1 = mastervalues.filter((mas: CodeMasterVO) => mas.codetype == READER_TYPE);
this.masterVO.READER_TYPE = READER_TYPE1;
}

}



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/service/MasterHelper.ts